// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HfgYwiaqNMxoC7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0 0 0;
  gap: 20px;
}
.DaI5DMrAwnzEY8 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fr5r5bo4uRd58c {
  font-weight: 500;
}
.ql6d1xLfBwy7w0 {
  display: flex;
  flex-direction: column;
  padding: 24px 48px 24px 48px;
  border-radius: 8px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  gap: 16px;
}
.ql6d1xLfBwy7w0 ul {
  margin-left: 18px;
  list-style-type: disc;
}
.ql6d1xLfBwy7w0 ul li::marker {
  font-size: x-small;
}
.XXFDZ9RT94DGXZ {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
}
.I5bfLvr2ftIcNP {
  gap: 8px;
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"freeSelectionInformationModal": `HfgYwiaqNMxoC7`,
	"modalHeader": `DaI5DMrAwnzEY8`,
	"modalTitle": `fr5r5bo4uRd58c`,
	"freeLimitsAndUnavailableFeatures": `ql6d1xLfBwy7w0`,
	"subheading": `XXFDZ9RT94DGXZ`,
	"modalFooter": `I5bfLvr2ftIcNP`
};
export default ___CSS_LOADER_EXPORT___;
